import { rootRequestWithHeaders } from './base-request';

export const getSpecialistSuggestions = urlQuery => {
  const url = `/search/network/suggestions?${urlQuery}`;
  const method = 'GET';
  return rootRequestWithHeaders(url, method, null, null);
};
